import styled from "styled-components";
import { useDataLayerContext } from "./ContextLayer/DataProvider/DataProvider";
import Strength from "./Strength";
import { useSettingsStorageContext } from "./ContextLayer/SettingsStorageProvider";
import gsap from "gsap";
import { DictionaryEntryType } from "./ContextLayer/DataProvider/types";
import { sortDictionary, useDictinaryFilter } from "./ContextLayer/DataProvider/CommonDataMethods";

const DictionaryAtom = styled.div<{$darkMode: boolean}>`
  // display: flex;
  // flex-direction: column;
  // justify-content: flex-start;
  // align-items: flex-start;
  // flex-grow: 1;
  width: 100%;
  height: 100%;

  border: 1px solid rgba(255, 255, 255, ${props => props.$darkMode ? '0' : '0.14'});
  border-radius: 18px;

  gap: 35px;
  overflow-y: scroll;
  overflow-x: hidden;

  box-shadow: 8px 8px 18px rgba(0, 0, 0, 0.07);

  background-color: ${props => props.$darkMode ? 'rgba(0, 0, 0, 0.14)' : 'rgba(255, 255, 255, 0.14)'};
  backdrop-filter: blur(25px);
  // padding: 10px 10px 10px 10px;
  padding-top: 10px;

  -ms-overflow-style: none;  /* Internet Explorer 10+ */
  scrollbar-width: none;  /* Firefox */

  box-sizing: border-box;

  cursor: default;

  // transition: border-color var(--transition-duration-slow), background-color var(--transition-duration-slow);
`

const DictionaryRowAtom = styled.div`
  width: 100%;
  height: 18px;
  overflow: hidden;
  font-family: 'FixelVariable', 'Fira Code', sans-serif;
  font-size: 0.75rem;

  margin-bottom: 3px;

  transition: height 150ms ease-in-out;

  &:hover {
    height: 36px;
    background-color: rgba(255, 255, 255, 0.3);
  }

  &:hover .wordSpan {
    font-weight: 800;
  }
`

const HardShellAtom = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  min-height: 15px;
  box-sizing: border-box;

  // background-color: lightgray;
`

const DisplayRowAtom = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 0px 15px 0px 15px;
  box-sizing: border-box;

  &.paddedRow {
    padding-left: 62px;
  }

  & span {
    font-family: 'FixelVariable', 'Fira Code', sans-serif;
    font-size: 0.75rem;
  }
`

const WordAtom = styled.span<{$darkMode: boolean}>`
  font-size: 1rem;
  font-weight: 500;
  letter-spacing: 0.3px;
  color: ${props => props.$darkMode ? '#d9d4c3ff' : '#101010'};
  transition: color var(--transition-duration-slow);

  &:hover {
    color: ${props => props.$darkMode ? '#FEF7E2' : '#101010'};
  }
`

const TagContainerAtom = styled.div<{$darkMode: boolean}>`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 3px;
  flex-grow: 1;

  & span {
    font-size: 0.7rem;
    color: ${props => props.$darkMode ? '#c9b6a4' : '#101010'};
    padding: 2px 5px;
    border-radius: 5px;
    background-color: ${props => props.$darkMode ? 'rgba(255, 255, 255, 0.08)' : 'rgba(255, 0, 0, 0.1)'};
    cursor: pointer;
    transition: background-color var(--transition-duration-slow), color var(--transition-duration-slow);

    &:hover {
      background-color: rgba(255, 0, 0, 0.2);
    }
  }
`

export type LANGUAGE_TYPE = 'native' | 'foreign';
export const NATIVE_LANGUAGE: 0  = 0;
export const FOREIGN_LANGUAGE: 1 = 1;

export default function Dictionary() {
  // const apiHost = withApiHost();
  const { dataLayer, setDataLayer } = useDataLayerContext();
  const { settings } = useSettingsStorageContext();
  // const populateDataLayer = useDataLayerPopulator();
  const filterDictonary = useDictinaryFilter();

  const setCurrentTag = (tag: string) => {
    try {
      gsap.to("#wordPair", {
        opacity: 0,
        duration: 0.3,
        ease: "power2.inOut",
        onComplete: () => {
            const newTags = (dataLayer?.tags || []).map(dataLayerTag => ({
              ...dataLayerTag,
              selected: dataLayerTag.tag === tag
            }));

            setDataLayer({
              ...dataLayer,
              tags: newTags
            });
        }
      });
    } catch (error) {
      console.error("Error recording correct answer:", error);
    } 
  }

  const filteredDictionary = filterDictonary(dataLayer.dictionary);
  const sortedDictionary = sortDictionary(filteredDictionary);

  return (
    <DictionaryAtom $darkMode={settings.darkMode}>
      {
        dataLayer.ready && (sortedDictionary || []).map((dictionaryItem: DictionaryEntryType) => {
          return (<DictionaryRowAtom key={dictionaryItem.id}>
            <HardShellAtom>
              <DisplayRowAtom>
                <Strength value={dictionaryItem.statistics?.strength | 0}/>
                <WordAtom className="wordSpan" $darkMode={settings.darkMode}>{ settings.currentLanguage === 'foreign' ? dictionaryItem.word : dictionaryItem.description }</WordAtom>
                <TagContainerAtom $darkMode={settings.darkMode}>{ dictionaryItem.tags.map(tag => <span key={tag} className='tags' onClick={() => setCurrentTag(tag)}>{tag}</span>) }</TagContainerAtom>
              </DisplayRowAtom>
              <DisplayRowAtom className="paddedRow">{settings.currentLanguage === 'foreign' ? dictionaryItem.description : dictionaryItem.word}</DisplayRowAtom>
            </HardShellAtom>
          </DictionaryRowAtom>)
        })
      }
    </DictionaryAtom>
  );
}